<template>
<el-dialog
  :visible='true'
  title=''
  :before-close='handleClose'
  width='940px'
>
  <div class="notShow">
    <el-image style="width: 100%;" v-if="type == 1" :src="url" :preview-src-list="[url]" alt=""></el-image>
    <video v-else-if="type == 2" style="border-radius: 6px;width: 100%;" controlslist="nodownload"
      ref="curVideo" preload="auto" controls="controls">
      <source :src="url" type="video/mp4">
    </video>
  </div>
</el-dialog>
</template>

<script>

export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  type:{
    type:Number,
    default:1
  },
  url:{
    type:String,
    default:''
  }
 },
 data() {
 return {
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  toSubmit() {
    // 跳转至  后台管理-富信资质
    this.$router.push({ name: 'media_qualification' })
  },
 }
}
</script>
<style lang='scss'>
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}

</style>
<style lang='scss' scoped>

/deep/ .el-dialog__header{
  border-bottom:none;
}
/deep/ .el-dialog__body{
  padding-top: 0;
}

.notShow {
  position: relative;
  text-align: center;
  top:-10px;
  overflow: hidden;

}
</style>